<template>
<f7-page class="journey-view">
  <template #fixed>
    <app-navbar title="Please Select A Menu"/>
  </template>

  <div class="menu-container">
    <img class="fork-left" src="@/assets/images/fork_left.png">
    <img class="fork-right" src="@/assets/images/fork_right.png">
    <f7-swiper class="menu-swiper"
        centered-slides loop
        :slides-per-view="2.4"
        :breakpoints="{
          960: { slidesPerView: 3 }
        }">
      <f7-swiper-slide v-for="(b, idx) of books" :key="idx" v-slot="{ isActive }">
        <div class="menu-book" :class="{ active: isActive }" @click="handleClickBook(idx)">
          <img class="background" src="@/assets/images/menu_bg.png">
          <div class="top-text">
            <div class="title">{{ b.title }}</div>
            <div class="sub-title">MENU</div>
          </div>
          <div class="time">Order Time {{ b.time }}</div>
          <div class="timeout" v-if="isTimeout(idx) && isActive">
            <div>Sorry, this menu timed out, you cannot selecte.</div>
          </div>
        </div>
      </f7-swiper-slide>
    </f7-swiper>
  </div>

  <f7-range class="time-slider"
    :min="0"
    :max="30"
    :step="1"
    v-model:value="timeValue" />
</f7-page>
</template>

<script>
import AppNavbar from '@/components/AppNavbar'

export default {
  components: { AppNavbar },

  props: {
    f7router: Object
  },

  data () {
    return {
      timeValue: 0,
      books: [
        { title: 'Breakfast', time: '6:30-9:30' },
        { title: 'Dinner', time: '11:30-13:00' },
        { title: 'Anytime', time: '00:00-24:00' }
      ]
    }
  },

  methods: {
    isTimeout (idx) {
      if (this.timeValue < 10) {
        return false
      } else if (this.timeValue >= 10 && this.timeValue < 20) {
        return idx <= 0
      } else if (this.timeValue >= 20 && this.timeValue < 30) {
        return idx <= 1
      } else {
        return true
      }
    },

    handleClickBook (idx) {
      if (this.isTimeout(idx)) { return }
      this.f7router.navigate('/selection')
    }
  }
}
</script>

<style lang="scss" scoped>
.journey-view {
  .menu-container {
    position: absolute; left: 0; right: 0; top: var(--f7-navbar-height); bottom: 200px;
    .fork-left { display: none; }
    .fork-right { display: none; }
    .menu-swiper {
      position: absolute; left: 0; right: 0;
      height: 100%;
      :deep(.swiper-slide) { display: flex; justify-content: center; align-items: center; }
      .menu-book {
        position: relative;
        text-align: center;
        transition: all .3s;
        transform: scale(0.7);
        border-radius: 8px;
        box-shadow: 0px 0px 20px 0px rgba(32, 15, 47, 0.8);
        &::after {
          content: ''; display: block;
          position: absolute; top: 2px; bottom: 2px; left: 2px; right: 2px;
          background: #160A28;
          opacity: 0.5;
          border-radius: 8px;
          transition: all .3s;
        }
        &.active {
          transform: scale(1);
          box-shadow: 0px 0px 50px 0px rgba(32, 15, 47, 0.8);
          &::after { opacity: 0; }
        }
        .background { display: block; max-width: 100%; max-height: 100%; }
        .top-text {
          position: absolute; top: 100px; left: 0; right: 0;
          .title { font-family: hand_write; font-size: 27px; font-weight: bold; margin-bottom: 10px; }
          .sub-title { font-size: 23px; font-style: italic; }
        }
        .time {
          position: absolute; bottom: 60px; left: 0; right: 0;
          font-weight: bold;
        }
        .timeout {
          position: absolute; top: 0; bottom: 0; left: 0; right: 0;
          font-size: 18px;
          display: flex; justify-content: center; align-items: center;
          border-radius: 8px;
          overflow: hidden;
          &::after {
            content: ''; display: block;
            position: absolute; top: 0; bottom: 0; left: 0; right: 0;
            background: linear-gradient(0deg, #160A28 0%, #0B0415 50%, #160A28 100%);
            opacity: 0.7;
          }
          > div {
            position: relative;
            text-align: center;
            z-index: 10;
            margin: 0 80px;
          }
        }
      }
    }
  }
  .time-slider {
    position: absolute; left: 50%; bottom: 120px;
    width: 550px;
    transform: translateX(-50%);

    --f7-range-bar-bg-color: #392C58;
    --f7-range-bar-active-bg-color: linear-gradient(90deg, #8166C3 0%, #A581E1 100%);
    --f7-range-bar-size: 6px;
    --f7-range-knob-size: 50px;

    :deep(.range-knob) {
      background: url(~@/assets/icons/airplane.png) no-repeat center / contain !important;
      border: none;
    }
  }

  @include media-landscape {
    .menu-container {
      left: 30px; right: 30px; bottom: 150px;
      .fork-left {
        display: block;
        position: absolute; left: 0; top: 50%;
        transform: translateY(-50%);
        width: 130px;
      }
      .fork-right {
        display: block;
        position: absolute; right: 0; top: 50%;
        transform: translateY(-50%);
        width: 130px;
      }
      .menu-swiper { left: 150px; right: 150px; }
    }
    .time-slider { bottom: 70px; }
  }
}
</style>
